// extracted by mini-css-extract-plugin
export default {"footerContainer":"CreateConversation__footerContainer___YGzAP","skeleton-loading":"CreateConversation__skeleton-loading___jGMPg"};